import React from "react";
import Projects from "./projects/Projects";
import { Row, Col } from "react-bootstrap";
import ProjectCard from "./projects/ProjectCard";
import projects from "../../content/projects";

const SoftwareDevelopmentPage = () => {
  return (
    <Projects header={{ label: "Software Development" }}>
      <p>
        I use the principles of software engineering to design, develop, and
        deploy computer software.
      </p>
      <Row>
        {projects.map((project, index) => {
          return (
            <Col key={index} xl={4} lg={6} md={6} sm={12}>
              <ProjectCard
                name={project.name}
                img={project.img}
                description={project.description}
              />
            </Col>
          );
        })}
      </Row>
    </Projects>
  );
};

export default SoftwareDevelopmentPage;
